import { FullScreenLoading as BaseFullScreenLoading } from "@mostrans/web-components/components/base/Loading";
import { useGlobalLoading } from "../shared/hooks/useGlobalLoading";

function FullScreenLoading() {
    const [loading] = useGlobalLoading();
    return (
        <BaseFullScreenLoading
            show={loading}
            loadingProps={{ sx: { zIndex: 100000 } }}
            backdropProps={{ sx: { zIndex: 100000 } }}
        />
    );
}

export default FullScreenLoading;
